import { render, staticRenderFns } from "./BrowseTable.vue?vue&type=template&id=66ea1462&scoped=true"
import script from "./BrowseTable.vue?vue&type=script&lang=ts"
export * from "./BrowseTable.vue?vue&type=script&lang=ts"
import style0 from "./BrowseTable.vue?vue&type=style&index=0&id=66ea1462&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ea1462",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ea1462')) {
      api.createRecord('66ea1462', component.options)
    } else {
      api.reload('66ea1462', component.options)
    }
    module.hot.accept("./BrowseTable.vue?vue&type=template&id=66ea1462&scoped=true", function () {
      api.rerender('66ea1462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseTable.vue"
export default component.exports